// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1tRbT","label":"Completed_label__3pJbi"};